export const setAnimationObserver = (element: Element, callback: () => void, threshold?: number) => {
  const option = {
    root: null,
    rootMargin: '0px',
    threshold: threshold || 0,
  }
  if ('IntersectionObserver' in window) {
    const observer: IntersectionObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      if (entries[0] && entries[0].isIntersecting) {
        callback()
        observer.unobserve(element)
      }
    }, option)
  
    observer.observe(element)
  } else {
    callback()
  }

}
